import { Modal } from '@design-system/components/modal/modal';
import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from './RemoveWorkoutLimitModal.css';

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const RemoveWorkoutLimitModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title="Remove workout limit?"
    centerContent
    testId="remove-workout-limit-modal"
  >
    <Typography variant="body" size="large" color="B-100" fontWeight="normal">
      Publishing newest at the bottom removes the workout limit.
    </Typography>
    <div className={styles.buttons}>
      <Button variant="text" color="neutral" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="filled" color="neutral" onClick={onConfirm}>
        Ok
      </Button>
    </div>
  </Modal>
);
